import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters({
      user: "userState",
    }),
    isRetailerSuspended() {
      return this.$store.getters.getUserStatus === "SUSPENDED";
    },
    isRetailerApproved() {
      return this.$store.getters.isRetailerApproved;
    },
  },
};
